var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loginBox"},[_c('div',{staticClass:"logincont"},[_c('span',{on:{"click":_vm.loginIn}},[_vm._v("登录")])])])}
var staticRenderFns = []

export { render, staticRenderFns }